module.exports = __webpack_public_path__ + "static/img/fullApp.fd39bdd7.png";